import type { DateVariableValue } from '@lighthouse/core'

export const DATE_SYSTEM: DateVariableValue[] = ['TODAY', 'TOMORROW', 'YESTERDAY']
